import { getStore } from '@/libs/storage'

const hasRole = {
  install (Vue, options) {
    Vue.directive('hasRole', {
      bind (el, binding) {
        let roles = getStore('roles')
        let bl = false
        let role = roles.split(',')
        console.log('role', role)
        let a = binding.value.a
        console.log('a', a)
        for (let i = 0; i < role.length; i++) {
          for (let j = 0; j < a.length; j++) {
            if (role[i] === a[j]) {
              bl = true
            }
          }
        }
        console.log(bl)
        if (!bl) {
          if (el.parentNode) {
            el.parentNode.removeChild(el)
          }
        }
      }
    })
  }
}

export default hasRole



// WEBPACK FOOTER //
// ./src/libs/hasRole.js